export default __webpack_public_path__ + "static/media/hero.a4a4cd9b.jpg";